import { Links } from '_types/public-api';

import { ExploreDropdownToggle } from './types';

export const exploreServicesFiltered = (links: Links | null | undefined, category: string) =>
  links?.data.filter((link) => link?.attributes?.category === category);

export const getDropdownToggleState = (links: Links | undefined, dropdownType: string): ExploreDropdownToggle => {
  if (links) {
    return links?.data.reduce((acc, link) => {
      if (dropdownType === 'main' && link?.attributes?.metadata?.level_2) {
        acc[link.attributes.metadata.level_2] = false;
      } else if (dropdownType === 'aside' && link?.attributes?.metadata?.level_1) {
        acc[link.attributes.metadata.level_1] = false;
      }
      return acc;
    }, {} as ExploreDropdownToggle);
  }
  return {} as ExploreDropdownToggle;
};
